export var AuthRoles;
(function (AuthRoles) {
    AuthRoles["ROLE_SCHOOL_ADMIN"] = "ROLE_SCHOOL_ADMIN";
    AuthRoles["ROLE_STUDENT"] = "ROLE_STUDENT";
    AuthRoles["ROLE_EMPLOYEE"] = "ROLE_EMPLOYEE";
})(AuthRoles || (AuthRoles = {}));
